import axios from 'axios';
import store from './store';

const Apiv3 = axios.create({
  baseURL: process.env.VUE_APP_API_URL_USER,
  headers: {
    Accept: 'application/json',
    // 'Access-Control-Allow-Origin': 'Authorization',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  mode: 'no-cors',
  credentials: true,
  crossdomain: true,
});

export function showErrorNotification(error) {
  let message =
    (error.response && error.response.data && error.response.data.message) ||
    '';

  let error_data =
    (error.response && error.response.data && error.response.data.errors) ||
    false;

  // kalau ada error unautorize clear localstorage
  store.dispatch('notification/showNotif', {
    message: message && message !== '' ? message : 'Tidak Dapat Mengakses Data',
    type: 'error',
  });

  return {
    message: message && message !== '' ? message : 'Tidak Dapat Mengakses Data',
    error_data,
  };
}

export function Apiv3GetRequest(url, data = {}) {
  return Apiv3.get(url, {
    params: data,
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function Apiv3PostMultipart(url, data = {}) {
  return Apiv3.post(url, data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function Apiv3GetUploadFile(url, data = {}, callbackUpload = () => {}) {
  return Apiv3.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event) => callbackUpload(event),
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export const Apiv3PostRequest = (url, data = {}) => {
  return Apiv3.post(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const Apiv3PutRequest = (url, data = {}) => {
  return Apiv3.put(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const Apiv3DeleteRequest = (url, data = {}) => {
  return Apiv3.delete(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};
